import { render } from "./Splash.vue?vue&type=template&id=5adb40df&scoped=true"
import script from "./Splash.vue?vue&type=script&lang=js"
export * from "./Splash.vue?vue&type=script&lang=js"

import "./Splash.vue?vue&type=style&index=0&id=5adb40df&lang=scss&scoped=true"

import exportComponent from "/Users/documedias/gitlab/virtuell/ispad2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5adb40df"]])

export default __exports__